import { makeAutoObservable } from 'mobx';
import apiConfig from '../api/routes';
import { FeatureSwitcherSelectorsType } from '../types';

export const selectorsNames = [
  'SHOW_WHO_IS_OFF_VERSION_3_FOR_AML', 'SHOW_WHO_IS_OFF_VERSION_3_FOR_AMC',
  'SHOW_AI_ASSISTANT_FOR_6_DEP', 'SHOW_AI_ASSISTANT_FOR_GDO'
];
export const defaultSelectorsResult:FeatureSwitcherSelectorsType = Object.fromEntries(selectorsNames.map(i =>  [i, {value: false, enabled: false, summaryValue: false}]));

class Class {
  
  
  featureFlags: Record<string, boolean> = {};
  featureSelectors: FeatureSwitcherSelectorsType = defaultSelectorsResult;
  constructor() {
    makeAutoObservable(this);
  }

  getFeatureFlags = async (payload: Record<string, boolean>) => {
    try {
      const res = await apiConfig.featureSwitcherService.getFlags();
      this.featureFlags = {...payload, ...res};
    }
    catch (e) {
      this.featureFlags = payload;
    }
  };

  getFeatureSelectors = async (variables: any, defaultResult: any) => {
    try {
      const res = await apiConfig.featureSwitcherService.getSelectors(variables);
      this.featureSelectors = {...defaultResult, ...res};
    }
    catch (e) {
      this.featureSelectors = defaultResult;
    }
  };
}

export const ProjectManagementStore = new Class();